import axios, { AxiosRequestConfig, CancelTokenSource } from 'axios'
import authService from '@/services/auth.service'
import { IGNORED_TOAST_ERROR_ENDPOINTS, HTTP_STATUS_UNAUTHORIZED } from '@/services/constants'
import store from '@/store'

let isRedirecting = false

const instance = axios.create({
  baseURL: process?.env?.CI ? process.env.VITE_APP_API_URL : import.meta.env.VITE_APP_API_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json'
  }
})

let cancelTokenSource: CancelTokenSource | null = null
let lastRequestIdentifier: string | null = null

instance.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response && error.response.status === HTTP_STATUS_UNAUTHORIZED) {
      if (!isRedirecting) {
        isRedirecting = true
        authService.logout().finally(() => {
          isRedirecting = false
        })

        if (!IGNORED_TOAST_ERROR_ENDPOINTS.some((ignoredEndpoint) => error.config.url.endsWith(ignoredEndpoint))) {
          const errData = error.response.data.error
          const description = typeof errData === 'string' ? errData : errData?.description
          store.dispatch('messages/addMessage', { message: description, type: 'error' })
        }
      }

      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

instance.interceptors.request.use((config: AxiosRequestConfig & { cancelRequest?: boolean }) => {
  if (config.cancelRequest) {
    const requestIdentifier = `${config.url}`

    if (cancelTokenSource && lastRequestIdentifier === requestIdentifier) {
      cancelTokenSource.cancel('Request canceled due to new input')
    }
    lastRequestIdentifier = requestIdentifier
    cancelTokenSource = axios.CancelToken.source()
    config.cancelToken = cancelTokenSource.token
  }

  if (store.state.user.tokens?.access_token && store.state.user.tokens.access_token !== '') {
    config.headers.Authorization = 'Bearer ' + store.state.user.tokens.access_token
  }
  return config
})

export default instance
